import PerfectScrollbar from "../vendors/perfect-scrollbar-1.4/dist/perfect-scrollbar.esm";

document.querySelectorAll('.scrollable').forEach(s => {
	new PerfectScrollbar(s);
});

document.querySelectorAll('.scrollable-x').forEach(s => {
	new PerfectScrollbar(s, {
		suppressScrollY: true,
		useBothWheelAxes: true,
	});
});

document.querySelectorAll('.scrollable-y').forEach(s => {
	new PerfectScrollbar(s, {
		suppressScrollX: true,
	});
});